import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React, { useState, useRef, useEffect, useContext } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import SignaturePad from "react-signature-pad-wrapper";
import ReplayIcon from "@mui/icons-material/Replay";
import ClearIcon from "@mui/icons-material/Clear";
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import "../index.css";
import axios from 'axios';
import { ProductContext } from "../context/AppContext";
import Footer from './Common_Components/Footer';
function WritingQuiz() {
    const location = useLocation();
    const [activePage, setActivePage] = useState("Learning");
    const navigate = useNavigate();
    const day = location.state?.day || "Day Module";
    const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    const signaturePadRef = useRef(null);
    const authToken = localStorage.getItem("AuthToken");
    const { Translate } = useContext(ProductContext);
    const [selectedOption, setSelectedOption] = useState(null);
    const [quizData, setQuizData] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(0);
    const [timeSpent, setTimeSpent] = useState(0);
    const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
    const [showSubmitMessage, setShowSubmitMessage] = useState(false);
    const [attemptStatus, setAttemptStatus] = useState(null);
    const [hasMoreQuestions, setHasMoreQuestions] = useState(true);
    const [attemptstatus22, setAttemptStatus22] = useState();
    const [attemptedQuestions, setAttemptedQuestions] = useState(0);
    const [loading, setLoading] = useState(false);
    const videoRef = useRef(null); // Create a reference to the video element
    const [isPlaying, setIsPlaying] = useState(false);
    const togglePlayPause = () => {
        if (isPlaying) {
            videoRef.current.pause(); // Pause the video if it's playing
        } else {
            videoRef.current.play(); // Play the video if it's paused
        }
        setIsPlaying(!isPlaying); // Toggle play/pause state
    };
    const categoryData = location.state; // Receive the state passed during navigation
    const category_id = categoryData?.category_id; // Match property name
    const categoryName = categoryData?.categoryName; // Match property name
    const level_id = categoryData?.level_id; // Match property name
    const total_time_spent = categoryData?.total_time_spent || 0; // Provide default value

    
    const quizTypeId = categoryData?.quizTypeId;
    const quizName = categoryData?.quizName;
    
                    

    console.log(
        "Received Writing Quiz data:",
        category_id, level_id, categoryName
    );
    const handleClear = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear();
        }
    };

    const handleUndo = () => {
        const data = signaturePadRef.current.toData();
        if (data) {
            data.pop(); // Remove the last stroke
            signaturePadRef.current.fromData(data);
        }
    };
    useEffect(() => {
        fetchQuizData(currentPage);
    }, [currentPage]);

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeSpent(prevTime => prevTime + 1);
        }, 1000);
        return () => clearInterval(timer);
    }, []);
    const fetchQuizData = async page => {
        setIsLoading(true);
        try {
            const response = await axios.get(
                `https://api.japaking.online/api/categories/${category_id}?page=${page}&size=6`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            if (response.data.success) {
                const newQuestions = response.data.message.category.questions;
                setQuizData(prevData => [
                    ...prevData,
                    ...newQuestions.filter(
                        q => !prevData.some(p => p.question_id === q.question_id),
                    ),
                ]);
                if (newQuestions.length < 6) {
                    setHasMoreQuestions(false);
                }
            }
        } catch (err) {
            if (err.response && err.response.status === 401) {
                console.log('navigate to login due to 401');
                navigate('/login'); // Navigate to login screen
            }
            console.log('Error fetching quiz data:', err);
        } finally {
            setIsLoading(false);
        }
    };
    const submitUserAttempt = async () => {
        const currentQuestion = quizData[currentQuestionIndex];
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        const userAttemptData = selectedOption
            ? selectedOptionData?.is_correct
                ? 'correct'
                : 'incorrect'
            : 'skipped';
        try {
            const response = await axios.post(
                `https://api.japaking.online/api/userAttempts`,
                userAttemptData,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );
            setAttemptStatus(response.data.message.attempt.attempt_status);
            setAttemptStatus22(response?.data?.message);
        } catch (error) {
            console.log('Error submitting user attempt:', error);
        }
    };
    const handleSubmit = async () => {
        await submitUserAttempt();
        setAttemptedQuestions(attemptedQuestions + 1);
        setShowSubmitMessage(true);
        const selectedOptionData = currentQuestion.options.find(
            option => option.option_id === selectedOption,
        );
        navigate('QuizTypeQuestion', {
            question: currentQuestion.question_text,
            selectedOption: selectedOption,
            allOptions: currentQuestion.options,
            currentQuestion,
            quizData,
            category_id,
            isCorrect: selectedOptionData.is_correct,
        });

        setShowSubmitMessage(true);
    };

    // const handleNextQuestion = () => {
    //     handleClear();
    //     setLoading(true);
    //     setTimeout(() => {
    //         if (currentQuestionIndex < quizData.length - 1) {
    //             setCurrentQuestionIndex(currentQuestionIndex + 1);
    //             setShowSubmitMessage(false);
    //             setSelectedOption(null);
    //         } else if (hasMoreQuestions) {
    //             setCurrentPage(nextPage => nextPage + 1);
    //             setCurrentQuestionIndex(currentQuestionIndex + 1);
    //             setShowSubmitMessage(false);
    //             setSelectedOption(null);
    //         }
    //         setLoading(false);
    //     }, 1000);
    // };

    const handleNextQuestion = () => {
    handleClear();
    setLoading(true);

    setTimeout(() => {
        // Case 1: Next question exists
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(prev => prev + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
        }
        // Case 2: Load more questions from API
        else if (hasMoreQuestions) {
            setCurrentPage(prev => prev + 1);
            setCurrentQuestionIndex(prev => prev + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
        }
        // Case 3: LAST QUESTION → Navigate to result page
        else {
            navigate('/thankyouwritingquiz', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    quizTypeId,
                    quizName,
                },
            });
        }

        setLoading(false);
    }, 1000);
};

    const currentQuestion = quizData[currentQuestionIndex];
    const progress22 = `${currentQuestionIndex + 1}/${quizData.length}`;

    if (isLoading) {
        // return (
        //   <View style={styles.LoadingImageDiv}>
        //     <Image source={LoadingImage} style={styles.LoadingImageCss} />
        //   </View>
        // );
    }
    const formatTime = seconds => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    };
    const handleMoveToQuestion = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            navigate('QuizTypeQuestion', {
                category_id: category_id,
            });
        } else {
            // navigate('/thank-you-quiz', {
            //     category_id: category_id,
            // });
            navigate('/thankyouwritingquiz', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    quizTypeId,
                    quizName
                },
            });
        }
        setShowSubmitMessage(false);
    };
    const handleStartNewQuiz = () => {
        if (currentQuestionIndex < quizData.length - 1) {
            // Move to the next question
            setCurrentQuestionIndex(currentQuestionIndex + 1);
            setShowSubmitMessage(false);
            setSelectedOption(null);
        } else if (hasMoreQuestions) {
            // Load more questions
            setCurrentPage(nextPage => nextPage + 1);
            setShowSubmitMessage(true);
            // setSelectedOption(null);
        } else {
            // Navigate to FinishQuiz when there are no more questions
            // navigate('/thank-you-quiz', {
            //     category_id: category_id,
            // });
            navigate('/lthankyouwritingquiz', {
                state: {
                    category_id,
                    level_id,
                    categoryName,
                    quizTypeId,
                    quizName
                },
            });
        }
    };
    // const handleNextQuestion = () => {
    //     // Move to the next question or loop back to the first question
    //     setCurrentQuestionIndex((prevIndex) =>
    //         prevIndex < japaneseQuestions.length - 1 ? prevIndex + 1 : 0
    //     );

    //     // Clear the signature pad for the next question
    //     handleClear();
    // };
    const [selectedLanguage, setSelectedLanguage] = useState('');
    // const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

    console.log(SelectLanguageLocal, "SelectLanguageLocal")
    useEffect(() => {
        const loadLanguage = async () => {
            try {
                const storedLanguage = localStorage.getItem("selectedLanguage");
                console.log("storedLanguage", storedLanguage);
                if (storedLanguage) {
                    setSelectedLanguage(storedLanguage);
                }
            } catch (error) {
                console.error("Error loading language:", error);
            }
        };

        loadLanguage();
    }, []);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    if (isLoadingImage) {

    }
    return (
        <div className="pratice-page-container">
            <div className="header_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <ArrowBackIosIcon onClick={() => navigate(-1)} className="icon_1" />
                            <h2>{Translate?.message?.data?.writingQuiz || "Writing Quiz"}</h2>
                            <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="pratice-page-rectangleBox">
                {/* Drawing Practice Section */}
                <div className="pratice-page-section">
                    <h2 className="pratice-page-header1">{Translate?.message?.data?.drawingPractice || "Drawing Practice"}</h2>
                    <div className="pratice-page-signaturePadContainer">
                        <div className="pratice-page-crossLineHorizontal"></div>
                        <div className="pratice-page-crossLineVertical"></div>
                        <SignaturePad
                            ref={signaturePadRef}
                            options={{
                                minWidth: 1,
                                maxWidth: 3,
                                penColor: "black",
                            }}
                            canvasProps={{
                                width: "100%",
                                height: "100%",
                                className: "pratice-page-signature-canvas",
                            }}
                        />
                    </div>
                    <div className="pratice-page-controls">
                        <div onClick={handleClear} className="pratice-page-controlIcon">
                            <ClearIcon />
                        </div>
                        <div onClick={handleUndo} className="pratice-page-controlIcon">
                            <ReplayIcon />
                        </div>
                    </div>
                </div>

                {/* Character Learning Section */}
                <div className="pratice-page-section">
                    <div className="pratice-page-header-container">
                        <h2 className="pratice-page-header">{Translate?.message?.data?.characterLearning || "Character Learning"}</h2>
                        <h2 className="pratice-page-subHeader">
                            {currentQuestion && currentQuestion.question_text
                                ? currentQuestion.question_text
                                : "Loading..."}
                        </h2>
                    </div>
                    <div className="pratice-page-videoContainer">
                        {currentQuestion && currentQuestion.url ? (
                            <video
                                className="pratice-page-videoPlayer"
                                src={
                                    isLoadingImage
                                        ? `${process.env.PUBLIC_URL}/assets/images/loading.png`
                                        : currentQuestion?.url
                                }
                                onLoadedData={() => setIsLoadingImage(false)} // Fires when video metadata has been loaded
                                onError={() => setIsLoadingImage(false)}
                                autoPlay={true} // Disable autoplay to avoid unexpected behaviors
                                controls
                                controlsList="nodownload"
                                ref={videoRef}
                                playsInline // Prevent fullscreen on mobile devices
                                webkit-playsinline="true" // For additional Safari support
                            >
                                Your browser does not support the video tag.
                            </video>
                        ) : (
                            <div>
                                <img
                                    src={`${process.env.PUBLIC_URL}/assets/images/loading.png`}
                                    alt="Loading..."
                                    className="lecture-video-placeholder"
                                />
                            </div>
                        )}
                    </div>




                    <div className="pratice-page-controls">

                        <button onClick={() => navigate("/")} className="pratice-page-button">
                            {Translate?.message?.data?.backToHome || "Back To Home"}
                        </button>
                        {/* <button
                            onClick={handleNextQuestion}
                            className="pratice-page-button"
                        >
                            {Translate?.message?.data?.nextQuestion || "Next Question"}
                        </button> */}
                        <button onClick={handleNextQuestion} className="pratice-page-button">
    {currentQuestionIndex === quizData.length - 1 && !hasMoreQuestions
        ? "Finish Quiz"
        : Translate?.message?.data?.nextQuestion || "Next Question"}
</button>

                    </div>

                </div>
            </div>
            <Footer />
        </div>
    );
};

export default WritingQuiz;
